// Rótulos que seguem o índice de correção da obra. `activeProject.indexer` é o documento da
// série (`{description, type, uf, value, date_used_in}`) ou o placeholder do back-end
// ("CUB - Em atualização" / "INCC - Em atualização"), então a família vem do começo da
// descrição. Obra sem índice conhecido segue como CUB, que era o único rótulo antes.
const INCC = 'INCC';
const CUB = 'CUB';

export const indexerFamily = (project) => {
  const description = String(project?.indexer?.description ?? '').trim().toUpperCase();
  return description.startsWith(INCC) ? INCC : CUB;
};

// O INCC é um número-índice, não um custo por m²: não faz sentido converter valores em
// "unidades de INCC", então a conversão R$/índice só vale para o CUB.
export const isInccIndexed = (project) => indexerFamily(project) === INCC;

// Sufixo curto dos valores convertidos e do texto "Variação do …".
export const indexerLabel = (project) => indexerFamily(project);

// Nome do card do índice: "INCC-DI" ou, para o CUB, "CUB - <categoria>" como hoje.
export const indexerCardName = (project) => {
  const indexer = project?.indexer ?? {};
  if (isInccIndexed(project)) {
    const variant = String(indexer.type ?? '').trim();
    return variant ? `${INCC}-${variant}` : String(indexer.description ?? INCC);
  }
  return `${indexer.description} - ${indexer.type}`;
};

export const indexerVariationLabel = (project) => (
  isInccIndexed(project) ? 'Variação do INCC (%)' : 'Variação de CUB (%)'
);
